import type { IconSvgObject } from './types';

const CircleArrowVerticalIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 17L12 7M12 17C12.5602 17 13.6068 15.604 14 15.25M12 17C11.4398 17 10.3932 15.604 10 15.25M12 7C12.5602 7 13.6068 8.39601 14 8.75M12 7C11.4398 7 10.3932 8.39601 10 8.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleArrowVerticalIcon;
